import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, Typography } from 'antd';
import { compliance } from '../config/compliance';

const { Title, Paragraph, Text } = Typography;

export default function LegalDocumentPage({ title, sections, relatedLinks = [] }) {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f6f7fb', padding: '24px 16px 48px' }}>
      <div style={{ maxWidth: 820, margin: '0 auto' }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          {title}
        </Title>
        <Text type="secondary">{compliance.companyName}</Text>

        <div style={{ margin: '16px 0 24px', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <a
            href="/login"
            onClick={(e) => {
              e.preventDefault();
              navigate('/login');
            }}
          >
            返回登录
          </a>
          {relatedLinks.map((item) => (
            <Link key={item.to} to={item.to}>
              {item.label}
            </Link>
          ))}
        </div>

        {sections.map((section) => (
          <Card key={section.title} style={{ marginBottom: 12, borderRadius: 16 }}>
            <Title level={5} style={{ marginTop: 0 }}>
              {section.title}
            </Title>
            <Paragraph style={{ marginBottom: 0, whiteSpace: 'pre-wrap' }}>
              {section.body}
            </Paragraph>
          </Card>
        ))}

        <footer style={{ marginTop: 28, textAlign: 'center', color: '#6b7280', fontSize: 14 }}>
          <a href={compliance.icpQueryUrl} target="_blank" rel="noopener noreferrer">
            {compliance.icpFilingNumber}
          </a>
        </footer>
      </div>
    </div>
  );
}
